import e from "./ghl-ui.es404.js";
import o from "./ghl-ui.es405.js";
import r from "./ghl-ui.es406.js";
import n from "./ghl-ui.es407.js";
import d from "./ghl-ui.es408.js";
import a from "./ghl-ui.es409.js";
import c from "./ghl-ui.es410.js";
import m from "./ghl-ui.es411.js";
import p from "./ghl-ui.es412.js";
import i from "./ghl-ui.es413.js";
import l from "./ghl-ui.es414.js";
import h from "./ghl-ui.es415.js";
import t from "./ghl-ui.es416.js";
import C from "./ghl-ui.es417.js";
import f from "./ghl-ui.es418.js";
import $ from "./ghl-ui.es419.js";
import s from "./ghl-ui.es420.js";
import u from "./ghl-ui.es421.js";
import S from "./ghl-ui.es422.js";
import M from "./ghl-ui.es423.js";
import G from "./ghl-ui.es424.js";
import B from "./ghl-ui.es425.js";
import I from "./ghl-ui.es426.js";
import g from "./ghl-ui.es427.js";
import A from "./ghl-ui.es428.js";
import N from "./ghl-ui.es429.js";
import T from "./ghl-ui.es430.js";
import b from "./ghl-ui.es431.js";
import P from "./ghl-ui.es432.js";
import y from "./ghl-ui.es433.js";
import K from "./ghl-ui.es434.js";
import L from "./ghl-ui.es435.js";
import R from "./ghl-ui.es436.js";
import E from "./ghl-ui.es437.js";
import k from "./ghl-ui.es438.js";
import F from "./ghl-ui.es439.js";
import v from "./ghl-ui.es440.js";
import D from "./ghl-ui.es441.js";
import U from "./ghl-ui.es442.js";
import V from "./ghl-ui.es443.js";
import H from "./ghl-ui.es444.js";
import z from "./ghl-ui.es445.js";
import O from "./ghl-ui.es446.js";
import w from "./ghl-ui.es447.js";
import J from "./ghl-ui.es448.js";
import Z from "./ghl-ui.es449.js";
import W from "./ghl-ui.es450.js";
import Y from "./ghl-ui.es451.js";
import q from "./ghl-ui.es452.js";
import j from "./ghl-ui.es453.js";
import Q from "./ghl-ui.es454.js";
import x from "./ghl-ui.es455.js";
import X from "./ghl-ui.es456.js";
import _ from "./ghl-ui.es457.js";
import ee from "./ghl-ui.es458.js";
import oe from "./ghl-ui.es459.js";
import re from "./ghl-ui.es460.js";
import ne from "./ghl-ui.es461.js";
import de from "./ghl-ui.es462.js";
import ae from "./ghl-ui.es463.js";
import ce from "./ghl-ui.es464.js";
import me from "./ghl-ui.es465.js";
import pe from "./ghl-ui.es466.js";
import ie from "./ghl-ui.es467.js";
import le from "./ghl-ui.es468.js";
import he from "./ghl-ui.es469.js";
import te from "./ghl-ui.es470.js";
import Ce from "./ghl-ui.es471.js";
import fe from "./ghl-ui.es472.js";
import $e from "./ghl-ui.es473.js";
import se from "./ghl-ui.es474.js";
import ue from "./ghl-ui.es475.js";
import Se from "./ghl-ui.es476.js";
import Me from "./ghl-ui.es477.js";
import Ge from "./ghl-ui.es478.js";
import Be from "./ghl-ui.es479.js";
import Ie from "./ghl-ui.es480.js";
import ge from "./ghl-ui.es481.js";
import Ae from "./ghl-ui.es482.js";
import Ne from "./ghl-ui.es483.js";
import Te from "./ghl-ui.es484.js";
import be from "./ghl-ui.es485.js";
import Pe from "./ghl-ui.es486.js";
import ye from "./ghl-ui.es487.js";
import Ke from "./ghl-ui.es488.js";
import Le from "./ghl-ui.es489.js";
import Re from "./ghl-ui.es490.js";
import Ee from "./ghl-ui.es491.js";
import ke from "./ghl-ui.es492.js";
import Fe from "./ghl-ui.es493.js";
import ve from "./ghl-ui.es494.js";
import De from "./ghl-ui.es495.js";
import Ue from "./ghl-ui.es496.js";
import Ve from "./ghl-ui.es497.js";
import He from "./ghl-ui.es498.js";
import ze from "./ghl-ui.es499.js";
import Oe from "./ghl-ui.es500.js";
import we from "./ghl-ui.es501.js";
import Je from "./ghl-ui.es502.js";
import Ze from "./ghl-ui.es503.js";
import We from "./ghl-ui.es504.js";
import Ye from "./ghl-ui.es505.js";
import qe from "./ghl-ui.es506.js";
import je from "./ghl-ui.es507.js";
import Qe from "./ghl-ui.es508.js";
import xe from "./ghl-ui.es509.js";
import Xe from "./ghl-ui.es510.js";
import _e from "./ghl-ui.es511.js";
import eo from "./ghl-ui.es512.js";
import oo from "./ghl-ui.es513.js";
import ro from "./ghl-ui.es514.js";
import no from "./ghl-ui.es515.js";
import ao from "./ghl-ui.es516.js";
import co from "./ghl-ui.es517.js";
import mo from "./ghl-ui.es518.js";
import po from "./ghl-ui.es519.js";
import io from "./ghl-ui.es520.js";
import lo from "./ghl-ui.es521.js";
import ho from "./ghl-ui.es522.js";
import to from "./ghl-ui.es523.js";
import Co from "./ghl-ui.es524.js";
import fo from "./ghl-ui.es525.js";
import $o from "./ghl-ui.es526.js";
import so from "./ghl-ui.es527.js";
import uo from "./ghl-ui.es528.js";
import So from "./ghl-ui.es529.js";
import Mo from "./ghl-ui.es530.js";
import Go from "./ghl-ui.es531.js";
import Bo from "./ghl-ui.es532.js";
import Io from "./ghl-ui.es533.js";
import go from "./ghl-ui.es534.js";
import Ao from "./ghl-ui.es535.js";
import No from "./ghl-ui.es536.js";
import To from "./ghl-ui.es537.js";
import bo from "./ghl-ui.es538.js";
import Po from "./ghl-ui.es539.js";
import yo from "./ghl-ui.es540.js";
import Ko from "./ghl-ui.es541.js";
import Lo from "./ghl-ui.es542.js";
import Ro from "./ghl-ui.es543.js";
import Eo from "./ghl-ui.es544.js";
import ko from "./ghl-ui.es545.js";
import Fo from "./ghl-ui.es546.js";
import vo from "./ghl-ui.es547.js";
import Do from "./ghl-ui.es548.js";
import Uo from "./ghl-ui.es549.js";
import Vo from "./ghl-ui.es550.js";
import Ho from "./ghl-ui.es551.js";
import zo from "./ghl-ui.es552.js";
import Oo from "./ghl-ui.es553.js";
import wo from "./ghl-ui.es554.js";
import Jo from "./ghl-ui.es555.js";
import Zo from "./ghl-ui.es556.js";
import Wo from "./ghl-ui.es557.js";
import Yo from "./ghl-ui.es558.js";
import qo from "./ghl-ui.es559.js";
import jo from "./ghl-ui.es560.js";
import Qo from "./ghl-ui.es561.js";
import xo from "./ghl-ui.es562.js";
import Xo from "./ghl-ui.es563.js";
import _o from "./ghl-ui.es564.js";
import er from "./ghl-ui.es565.js";
import or from "./ghl-ui.es566.js";
import rr from "./ghl-ui.es567.js";
import nr from "./ghl-ui.es568.js";
import dr from "./ghl-ui.es569.js";
import ar from "./ghl-ui.es570.js";
import cr from "./ghl-ui.es571.js";
import mr from "./ghl-ui.es572.js";
import pr from "./ghl-ui.es573.js";
import ir from "./ghl-ui.es574.js";
import lr from "./ghl-ui.es575.js";
import hr from "./ghl-ui.es576.js";
import tr from "./ghl-ui.es577.js";
import Cr from "./ghl-ui.es578.js";
import fr from "./ghl-ui.es579.js";
import $r from "./ghl-ui.es580.js";
import sr from "./ghl-ui.es581.js";
import ur from "./ghl-ui.es582.js";
import Sr from "./ghl-ui.es583.js";
import Mr from "./ghl-ui.es584.js";
import Gr from "./ghl-ui.es585.js";
import Br from "./ghl-ui.es586.js";
import Ir from "./ghl-ui.es587.js";
import gr from "./ghl-ui.es588.js";
import Ar from "./ghl-ui.es589.js";
import Nr from "./ghl-ui.es590.js";
import Tr from "./ghl-ui.es591.js";
import br from "./ghl-ui.es592.js";
import Pr from "./ghl-ui.es593.js";
import yr from "./ghl-ui.es594.js";
import Kr from "./ghl-ui.es595.js";
import Lr from "./ghl-ui.es596.js";
import Rr from "./ghl-ui.es597.js";
import Er from "./ghl-ui.es598.js";
import kr from "./ghl-ui.es599.js";
import Fr from "./ghl-ui.es600.js";
import vr from "./ghl-ui.es601.js";
import Dr from "./ghl-ui.es602.js";
import Ur from "./ghl-ui.es603.js";
import Vr from "./ghl-ui.es604.js";
import Hr from "./ghl-ui.es605.js";
import zr from "./ghl-ui.es606.js";
import Or from "./ghl-ui.es607.js";
import wr from "./ghl-ui.es608.js";
import Jr from "./ghl-ui.es609.js";
import Zr from "./ghl-ui.es610.js";
import Wr from "./ghl-ui.es611.js";
import Yr from "./ghl-ui.es612.js";
import qr from "./ghl-ui.es613.js";
import jr from "./ghl-ui.es614.js";
import Qr from "./ghl-ui.es615.js";
import xr from "./ghl-ui.es616.js";
import Xr from "./ghl-ui.es617.js";
import _r from "./ghl-ui.es618.js";
import en from "./ghl-ui.es619.js";
import on from "./ghl-ui.es620.js";
import rn from "./ghl-ui.es621.js";
import nn from "./ghl-ui.es622.js";
import dn from "./ghl-ui.es623.js";
import an from "./ghl-ui.es624.js";
import cn from "./ghl-ui.es625.js";
import mn from "./ghl-ui.es626.js";
import pn from "./ghl-ui.es627.js";
import ln from "./ghl-ui.es628.js";
import hn from "./ghl-ui.es629.js";
import tn from "./ghl-ui.es630.js";
import Cn from "./ghl-ui.es631.js";
import fn from "./ghl-ui.es632.js";
import $n from "./ghl-ui.es633.js";
import sn from "./ghl-ui.es634.js";
import un from "./ghl-ui.es635.js";
import Sn from "./ghl-ui.es636.js";
import Mn from "./ghl-ui.es637.js";
import Gn from "./ghl-ui.es638.js";
import Bn from "./ghl-ui.es639.js";
import In from "./ghl-ui.es640.js";
import gn from "./ghl-ui.es641.js";
import An from "./ghl-ui.es642.js";
import Nn from "./ghl-ui.es643.js";
import Tn from "./ghl-ui.es644.js";
import bn from "./ghl-ui.es645.js";
import Pn from "./ghl-ui.es646.js";
import yn from "./ghl-ui.es647.js";
import Kn from "./ghl-ui.es648.js";
import Ln from "./ghl-ui.es649.js";
import Rn from "./ghl-ui.es650.js";
const lp = [
  {
    name: "Afghanistan (افغانستان)",
    code: "AF",
    phoneCode: "+93",
    placeholder: "070 123 4567",
    icon: e
  },
  {
    name: "Åland Islands",
    code: "AX",
    phoneCode: "+358",
    placeholder: "041 2345678",
    icon: o
  },
  {
    name: "Albania (Shqipëri)",
    code: "AL",
    phoneCode: "+355",
    placeholder: "066 123 4567",
    icon: r
  },
  {
    name: "Algeria (الجزائر)",
    code: "DZ",
    phoneCode: "+213",
    placeholder: "05 12 34 56 78",
    icon: n
  },
  {
    name: "American Samoa",
    code: "AS",
    phoneCode: "+1",
    placeholder: "(684) 733-1234",
    icon: d
  },
  {
    name: "Andorra",
    code: "AD",
    phoneCode: "+376",
    placeholder: "312 345",
    icon: a
  },
  {
    name: "Angola",
    code: "AO",
    phoneCode: "+244",
    placeholder: "923 123 456",
    icon: c
  },
  {
    name: "Anguilla",
    code: "AI",
    phoneCode: "+1",
    placeholder: "(264) 235-1234",
    icon: m
  },
  {
    name: "Antigua and Barbuda",
    code: "AG",
    phoneCode: "+1",
    placeholder: "(268) 722-1234",
    icon: p
  },
  {
    name: "Argentina",
    code: "AR",
    phoneCode: "+54",
    placeholder: "011 15-2345-6789",
    icon: i
  },
  {
    name: "Armenia (Հայաստան)",
    code: "AM",
    phoneCode: "+374",
    placeholder: "077 123456",
    icon: l
  },
  {
    name: "Aruba",
    code: "AW",
    phoneCode: "+297",
    placeholder: "560-1234",
    icon: h
  },
  {
    name: "Ascension Island",
    code: "AC",
    phoneCode: "+247",
    placeholder: "3 2250",
    icon: t
  },
  {
    name: "Australia",
    code: "AU",
    phoneCode: "+61",
    placeholder: "0412 345 678",
    icon: C
  },
  {
    name: "Austria (Österreich)",
    code: "AT",
    phoneCode: "+43",
    placeholder: "0664 123456",
    icon: f
  },
  {
    name: "Azerbaijan (Azərbaycan)",
    code: "AZ",
    phoneCode: "+994",
    placeholder: "040 123 45 67",
    icon: $
  },
  {
    name: "Bahamas",
    code: "BS",
    phoneCode: "+1",
    placeholder: "(242) 359-1234",
    icon: s
  },
  {
    name: "Bahrain (البحرين)",
    code: "BH",
    phoneCode: "+973",
    placeholder: "3600 1234",
    icon: u
  },
  {
    name: "Bangladesh (বাংলাদেশ)",
    code: "BD",
    phoneCode: "+880",
    placeholder: "01812-345678",
    icon: S
  },
  {
    name: "Barbados",
    code: "BB",
    phoneCode: "+1",
    placeholder: "(246) 250-1234",
    icon: M
  },
  {
    name: "Belarus (Беларусь)",
    code: "BY",
    phoneCode: "+375",
    placeholder: "8 029 491-19-11",
    icon: G
  },
  {
    name: "Belgium (België)",
    code: "BE",
    phoneCode: "+32",
    placeholder: "0470 12 34 56",
    icon: B
  },
  {
    name: "Belize",
    code: "BZ",
    phoneCode: "+501",
    placeholder: "622-1234",
    icon: I
  },
  {
    name: "Benin (Bénin)",
    code: "BJ",
    phoneCode: "+229",
    placeholder: "90 01 12 34",
    icon: g
  },
  {
    name: "Bermuda",
    code: "BM",
    phoneCode: "+1",
    placeholder: "(441) 370-1234",
    icon: A
  },
  {
    name: "Bhutan (འབྲུག)",
    code: "BT",
    phoneCode: "+975",
    placeholder: "17 12 34 56",
    icon: N
  },
  {
    name: "Bolivia",
    code: "BO",
    phoneCode: "+591",
    placeholder: "71234567",
    icon: T
  },
  {
    name: "Bosnia and Herzegovina (Босна и Херцеговина)",
    code: "BA",
    phoneCode: "+387",
    placeholder: "061 123 456",
    icon: P
  },
  {
    name: "Botswana",
    code: "BW",
    phoneCode: "+267",
    placeholder: "71 123 456",
    icon: y
  },
  {
    name: "Brazil (Brasil)",
    code: "BR",
    phoneCode: "+55",
    placeholder: "(11) 91234-5678",
    icon: K
  },
  {
    name: "British Indian Ocean Territory",
    code: "IO",
    phoneCode: "+246",
    placeholder: "370 5123",
    icon: L
  },
  {
    name: "British Virgin Islands",
    code: "VG",
    phoneCode: "+1",
    placeholder: "(284) 300-1234",
    icon: R
  },
  {
    name: "Brunei",
    code: "BN",
    phoneCode: "+673",
    placeholder: "712 3456",
    icon: E
  },
  {
    name: "Bulgaria (България)",
    code: "BG",
    phoneCode: "+359",
    placeholder: "0881 234 567",
    icon: k
  },
  {
    name: "Burkina Faso",
    code: "BF",
    phoneCode: "+226",
    placeholder: "70 12 34 56",
    icon: F
  },
  {
    name: "Burundi (Uburundi)",
    code: "BI",
    phoneCode: "+257",
    placeholder: "79 56 12 34",
    icon: D
  },
  {
    name: "Cambodia (កម្ពុជា)",
    code: "KH",
    phoneCode: "+855",
    placeholder: "091 234 567",
    icon: U
  },
  {
    name: "Cameroon (Cameroun)",
    code: "CM",
    phoneCode: "+237",
    placeholder: "6 71 23 45 67",
    icon: V
  },
  {
    name: "Canada",
    code: "CA",
    phoneCode: "+1",
    placeholder: "(204) 123-4567",
    icon: H
  },
  {
    name: "Cape Verde (Kabu Verdi)",
    code: "CV",
    phoneCode: "+238",
    placeholder: "991 12 34",
    icon: z
  },
  {
    name: "Bonaire (Caribbean Netherlands)",
    code: "BQ",
    phoneCode: "+599",
    placeholder: "318 1234",
    icon: b
  },
  {
    name: "Cayman Islands",
    code: "KY",
    phoneCode: "+1",
    placeholder: "(345) 323-1234",
    icon: O
  },
  {
    name: "Central African Republic (République centrafricaine)",
    code: "CF",
    phoneCode: "+236",
    placeholder: "70 01 23 45",
    icon: w
  },
  {
    name: "Chad (Tchad)",
    code: "TD",
    phoneCode: "+235",
    placeholder: "63 01 23 45",
    icon: J
  },
  {
    name: "Chile",
    code: "CL",
    phoneCode: "+56",
    placeholder: "9 9123 4567",
    icon: Z
  },
  {
    name: "China (中国)",
    code: "CN",
    phoneCode: "+86",
    placeholder: "131 2345 6789",
    icon: W
  },
  {
    name: "Christmas Island",
    code: "CX",
    phoneCode: "+61",
    placeholder: "0412 345 678",
    icon: Y
  },
  {
    name: "Cocos (Keeling) Islands",
    code: "CC",
    phoneCode: "+61",
    placeholder: "0412 345 678",
    icon: q
  },
  {
    name: "Colombia",
    code: "CO",
    phoneCode: "+57",
    placeholder: "321 1234567",
    icon: j
  },
  {
    name: "Comoros (جزر القمر)",
    code: "KM",
    phoneCode: "+269",
    placeholder: "321 12 34",
    icon: Q
  },
  {
    name: "Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)",
    code: "CD",
    phoneCode: "+243",
    placeholder: "081 234 5678",
    icon: X
  },
  {
    name: "Congo (Republic) (Congo-Brazzaville)",
    code: "CG",
    phoneCode: "+242",
    placeholder: "06 123 4567",
    icon: x
  },
  {
    name: "Cook Islands",
    code: "CK",
    phoneCode: "+682",
    placeholder: "21 234",
    icon: _
  },
  {
    name: "Costa Rica",
    code: "CR",
    phoneCode: "+506",
    placeholder: "8312 3456",
    icon: ee
  },
  {
    name: "Côte d’Ivoire",
    code: "CI",
    phoneCode: "+225",
    placeholder: "01 23 45 67",
    icon: oe
  },
  {
    name: "Croatia (Hrvatska)",
    code: "HR",
    phoneCode: "+385",
    placeholder: "091 234 5678",
    icon: re
  },
  {
    name: "Cuba",
    code: "CU",
    phoneCode: "+53",
    placeholder: "05 1234567",
    icon: ne
  },
  {
    name: "Curaçao",
    code: "CW",
    phoneCode: "+599",
    placeholder: "9 512 3456",
    icon: de
  },
  {
    name: "Cyprus (Κύπρος)",
    code: "CY",
    phoneCode: "+357",
    placeholder: "96 123456",
    icon: ae
  },
  {
    name: "Czech Republic (Česká republika)",
    code: "CZ",
    phoneCode: "+420",
    placeholder: "601 123 456",
    icon: ce
  },
  {
    name: "Denmark (Danmark)",
    code: "DK",
    phoneCode: "+45",
    placeholder: "20 12 34 56",
    icon: me
  },
  {
    name: "Djibouti",
    code: "DJ",
    phoneCode: "+253",
    placeholder: "77 83 10 20",
    icon: pe
  },
  {
    name: "Dominica",
    code: "DM",
    phoneCode: "+1",
    placeholder: "(767) 225-1234",
    icon: ie
  },
  {
    name: "Dominican Republic (República Dominicana)",
    code: "DO",
    phoneCode: "+1",
    placeholder: "(809) 234-5678",
    icon: le
  },
  {
    name: "Ecuador",
    code: "EC",
    phoneCode: "+593",
    placeholder: "099 123 4567",
    icon: he
  },
  {
    name: "Egypt (مصر)",
    code: "EG",
    phoneCode: "+20",
    placeholder: "0100 123 4567",
    icon: te
  },
  {
    name: "El Salvador",
    code: "SV",
    phoneCode: "+503",
    placeholder: "7012 3456",
    icon: Ce
  },
  {
    name: "Equatorial Guinea (Guinea Ecuatorial)",
    code: "GQ",
    phoneCode: "+240",
    placeholder: "222 123 456",
    icon: fe
  },
  {
    name: "Eritrea",
    code: "ER",
    phoneCode: "+291",
    placeholder: "07 123 456",
    icon: $e
  },
  {
    name: "Estonia (Eesti)",
    code: "EE",
    phoneCode: "+372",
    placeholder: "5123 4567",
    icon: se
  },
  {
    name: "Eswatini",
    code: "SZ",
    phoneCode: "+268",
    placeholder: "7612 3456",
    icon: ue
  },
  {
    name: "Ethiopia",
    code: "ET",
    phoneCode: "+251",
    placeholder: "091 123 4567",
    icon: Se
  },
  {
    name: "Falkland Islands (Islas Malvinas)",
    code: "FK",
    phoneCode: "+500",
    placeholder: "51234",
    icon: Me
  },
  {
    name: "Faroe Islands (Føroyar)",
    code: "FO",
    phoneCode: "+298",
    placeholder: "211234",
    icon: Ge
  },
  {
    name: "Fiji",
    code: "FJ",
    phoneCode: "+679",
    placeholder: "701 2345",
    icon: Be
  },
  {
    name: "Finland (Suomi)",
    code: "FI",
    phoneCode: "+358",
    placeholder: "041 2345678",
    icon: Ie
  },
  {
    name: "France",
    code: "FR",
    phoneCode: "+33",
    placeholder: "06 12 34 56 78",
    icon: ge
  },
  {
    name: "French Guiana (Guyane française)",
    code: "GF",
    phoneCode: "+594",
    placeholder: "0694 20 12 34",
    icon: Ae
  },
  {
    name: "French Polynesia (Polynésie française)",
    code: "PF",
    phoneCode: "+689",
    placeholder: "87 12 34 56",
    icon: Ne
  },
  {
    name: "Gabon",
    code: "GA",
    phoneCode: "+241",
    placeholder: "06 03 12 34",
    icon: Te
  },
  {
    name: "Gambia",
    code: "GM",
    phoneCode: "+220",
    placeholder: "301 2345",
    icon: be
  },
  {
    name: "Georgia (საქართველო)",
    code: "GE",
    phoneCode: "+995",
    placeholder: "555 12 34 56",
    icon: Pe
  },
  {
    name: "Germany (Deutschland)",
    code: "DE",
    phoneCode: "+49",
    placeholder: "01512 3456789",
    icon: ye
  },
  {
    name: "Ghana (Gaana)",
    code: "GH",
    phoneCode: "+233",
    placeholder: "023 123 4567",
    icon: Ke
  },
  {
    name: "Gibraltar",
    code: "GI",
    phoneCode: "+350",
    placeholder: "57123456",
    icon: Le
  },
  {
    name: "Greece (Ελλάδα)",
    code: "GR",
    phoneCode: "+30",
    placeholder: "691 234 5678",
    icon: Re
  },
  {
    name: "Greenland (Kalaallit Nunaat)",
    code: "GL",
    phoneCode: "+299",
    placeholder: "22 12 34",
    icon: Ee
  },
  {
    name: "Grenada",
    code: "GD",
    phoneCode: "+1",
    placeholder: "(473) 403-1234",
    icon: ke
  },
  {
    name: "Guadeloupe",
    code: "GP",
    phoneCode: "+590",
    placeholder: "0690 30 12 34",
    icon: Fe
  },
  {
    name: "Guam",
    code: "GU",
    phoneCode: "+1",
    placeholder: "(671) 300-1234",
    icon: ve
  },
  {
    name: "Guatemala",
    code: "GT",
    phoneCode: "+502",
    placeholder: "5123 4567",
    icon: De
  },
  {
    name: "Guernsey",
    code: "GG",
    phoneCode: "+44",
    placeholder: "07781 123456",
    icon: Ue
  },
  {
    name: "Guinea (Guinée)",
    code: "GN",
    phoneCode: "+224",
    placeholder: "601 12 34 56",
    icon: He
  },
  {
    name: "Guinea-Bissau (Guiné Bissau)",
    code: "GW",
    phoneCode: "+245",
    placeholder: "955 123 456",
    icon: Ve
  },
  {
    name: "Guyana",
    code: "GY",
    phoneCode: "+592",
    placeholder: "609 1234",
    icon: ze
  },
  {
    name: "Haiti",
    code: "HT",
    phoneCode: "+509",
    placeholder: "34 10 1234",
    icon: Oe
  },
  {
    name: "Honduras",
    code: "HN",
    phoneCode: "+504",
    placeholder: "9123-4567",
    icon: we
  },
  {
    name: "Hong Kong (香港)",
    code: "HK",
    phoneCode: "+852",
    placeholder: "5123 4567",
    icon: Je
  },
  {
    name: "Hungary (Magyarország)",
    code: "HU",
    phoneCode: "+36",
    placeholder: "20 123 4567",
    icon: Ze
  },
  {
    name: "Iceland (Ísland)",
    code: "IS",
    phoneCode: "+354",
    placeholder: "611 1234",
    icon: We
  },
  {
    name: "India (भारत)",
    code: "IN",
    phoneCode: "+91",
    placeholder: "90123 45678",
    icon: Ye
  },
  {
    name: "Indonesia",
    code: "ID",
    phoneCode: "+62",
    placeholder: "0812-345-678",
    icon: qe
  },
  {
    name: "Iran (ایران)",
    code: "IR",
    phoneCode: "+98",
    placeholder: "0912 345 6789",
    icon: je
  },
  {
    name: "Iraq (العراق)",
    code: "IQ",
    phoneCode: "+964",
    placeholder: "0791 234 5678",
    icon: Qe
  },
  {
    name: "Ireland",
    code: "IE",
    phoneCode: "+353",
    placeholder: "085 123 4567",
    icon: xe
  },
  {
    name: "Isle of Man",
    code: "IM",
    phoneCode: "+44",
    placeholder: "07924 123456",
    icon: Xe
  },
  {
    name: "Israel (ישראל)",
    code: "IL",
    phoneCode: "+972",
    placeholder: "050-123-4567",
    icon: _e
  },
  {
    name: "Italy (Italia)",
    code: "IT",
    phoneCode: "+39",
    placeholder: "312 345 6789",
    icon: eo
  },
  {
    name: "Jamaica",
    code: "JM",
    phoneCode: "+1",
    placeholder: "(876) 210-1234",
    icon: oo
  },
  {
    name: "Japan (日本)",
    code: "JP",
    phoneCode: "+81",
    placeholder: "090-1234-5678",
    icon: ro
  },
  {
    name: "Jersey",
    code: "JE",
    phoneCode: "+44",
    placeholder: "07797 123456",
    icon: no
  },
  {
    name: "Jordan (الأردن)",
    code: "JO",
    phoneCode: "+962",
    placeholder: "07 9012 3456",
    icon: ao
  },
  {
    name: "Kazakhstan (Казахстан)",
    code: "KZ",
    phoneCode: "+7",
    placeholder: "8 (771) 000 9998",
    icon: co
  },
  {
    name: "Kenya",
    code: "KE",
    phoneCode: "+254",
    placeholder: "0712 123456",
    icon: mo
  },
  {
    name: "Kiribati",
    code: "KI",
    phoneCode: "+686",
    placeholder: "72012345",
    icon: po
  },
  {
    name: "Kosovo",
    code: "XK",
    phoneCode: "+383",
    placeholder: "044 123 456",
    icon: io
  },
  {
    name: "Kuwait (الكويت)",
    code: "KW",
    phoneCode: "+965",
    placeholder: "50012345",
    icon: lo
  },
  {
    name: "Kyrgyzstan (Кыргызстан)",
    code: "KG",
    phoneCode: "+996",
    placeholder: "0700 123 456",
    icon: ho
  },
  {
    name: "Laos (ລາວ)",
    code: "LA",
    phoneCode: "+856",
    placeholder: "020 23 123 456",
    icon: to
  },
  {
    name: "Latvia (Latvija)",
    code: "LV",
    phoneCode: "+371",
    placeholder: "21 234 567",
    icon: Co
  },
  {
    name: "Lebanon (لبنان)",
    code: "LB",
    phoneCode: "+961",
    placeholder: "03 123 456",
    icon: fo
  },
  {
    name: "Lesotho",
    code: "LS",
    phoneCode: "+266",
    placeholder: "5012 3456",
    icon: $o
  },
  {
    name: "Liberia",
    code: "LR",
    phoneCode: "+231",
    placeholder: "077 012 3456",
    icon: so
  },
  {
    name: "Libya (ليبيا)",
    code: "LY",
    phoneCode: "+218",
    placeholder: "091-2345678",
    icon: uo
  },
  {
    name: "Liechtenstein",
    code: "LI",
    phoneCode: "+423",
    placeholder: "660 234 567",
    icon: So
  },
  {
    name: "Lithuania (Lietuva)",
    code: "LT",
    phoneCode: "+370",
    placeholder: "612 34567",
    icon: Mo
  },
  {
    name: "Luxembourg",
    code: "LU",
    phoneCode: "+352",
    placeholder: "621 123 456",
    icon: Go
  },
  {
    name: "Macau",
    code: "MO",
    phoneCode: "+853",
    placeholder: "6612 3456",
    icon: Bo
  },
  {
    name: "Madagascar (Madagasikara)",
    code: "MG",
    phoneCode: "+261",
    placeholder: "032 12 345 67",
    icon: go
  },
  {
    name: "Malawi",
    code: "MW",
    phoneCode: "+265",
    placeholder: "0991 23 45 67",
    icon: Ao
  },
  {
    name: "Malaysia",
    code: "MY",
    phoneCode: "+60",
    placeholder: "012-345 6789",
    icon: No
  },
  {
    name: "Maldives",
    code: "MV",
    phoneCode: "+960",
    placeholder: "771-2345",
    icon: To
  },
  {
    name: "Mali",
    code: "ML",
    phoneCode: "+223",
    placeholder: "60 12 34 56",
    icon: bo
  },
  {
    name: "Malta",
    code: "MT",
    phoneCode: "+356",
    placeholder: "9696 1234",
    icon: Po
  },
  {
    name: "Marshall Islands",
    code: "MH",
    phoneCode: "+692",
    placeholder: "235-1234",
    icon: yo
  },
  {
    name: "Martinique",
    code: "MQ",
    phoneCode: "+596",
    placeholder: "0696 20 12 34",
    icon: Ko
  },
  {
    name: "Mauritania (موريتانيا)",
    code: "MR",
    phoneCode: "+222",
    placeholder: "22 12 34 56",
    icon: Lo
  },
  {
    name: "Mauritius (Moris)",
    code: "MU",
    phoneCode: "+230",
    placeholder: "5251 2345",
    icon: Ro
  },
  {
    name: "Mayotte",
    code: "YT",
    phoneCode: "+262",
    placeholder: "0639 01 23 45",
    icon: Eo
  },
  {
    name: "Mexico (México)",
    code: "MX",
    phoneCode: "+52",
    placeholder: "044 55 1234 5678",
    icon: ko
  },
  {
    name: "Micronesia",
    code: "FM",
    phoneCode: "+691",
    placeholder: "350 1234",
    icon: Fo
  },
  {
    name: "Moldova (Republica Moldova)",
    code: "MD",
    phoneCode: "+373",
    placeholder: "0621 12 345",
    icon: vo
  },
  {
    name: "Monaco",
    code: "MC",
    phoneCode: "+377",
    placeholder: "06 12 34 56 78",
    icon: Do
  },
  {
    name: "Mongolia (Монгол)",
    code: "MN",
    phoneCode: "+976",
    placeholder: "8812 3456",
    icon: Uo
  },
  {
    name: "Montenegro (Crna Gora)",
    code: "ME",
    phoneCode: "+382",
    placeholder: "067 123 456",
    icon: Vo
  },
  {
    name: "Montserrat",
    code: "MS",
    phoneCode: "+1",
    placeholder: "(664) 492-3456",
    icon: Ho
  },
  {
    name: "Morocco (المغرب)",
    code: "MA",
    phoneCode: "+212",
    placeholder: "0650-123456",
    icon: zo
  },
  {
    name: "Mozambique (Moçambique)",
    code: "MZ",
    phoneCode: "+258",
    placeholder: "82 123 4567",
    icon: Oo
  },
  {
    name: "Myanmar (Burma) (မြန်မာ)",
    code: "MM",
    phoneCode: "+95",
    placeholder: "09 123 4567",
    icon: v
  },
  {
    name: "Namibia (Namibië)",
    code: "NA",
    phoneCode: "+264",
    placeholder: "081 123 4567",
    icon: wo
  },
  {
    name: "Nauru",
    code: "NR",
    phoneCode: "+674",
    placeholder: "555 1234",
    icon: Jo
  },
  {
    name: "Nepal (नेपाल)",
    code: "NP",
    phoneCode: "+977",
    placeholder: "984-1234567",
    icon: Zo
  },
  {
    name: "Netherlands (Nederland)",
    code: "NL",
    phoneCode: "+31",
    placeholder: "06 12345678",
    icon: Wo
  },
  {
    name: "New Caledonia (Nouvelle-Calédonie)",
    code: "NC",
    phoneCode: "+687",
    placeholder: "75.12.34",
    icon: Yo
  },
  {
    name: "New Zealand",
    code: "NZ",
    phoneCode: "+64",
    placeholder: "021 123 456",
    icon: qo
  },
  {
    name: "Nicaragua",
    code: "NI",
    phoneCode: "+505",
    placeholder: "8123 4567",
    icon: jo
  },
  {
    name: "Niger (Nijar)",
    code: "NE",
    phoneCode: "+227",
    placeholder: "93 12 34 56",
    icon: Qo
  },
  {
    name: "Nigeria",
    code: "NG",
    phoneCode: "+234",
    placeholder: "0802 123 4567",
    icon: xo
  },
  {
    name: "Niue",
    code: "NU",
    phoneCode: "+683",
    placeholder: "1234",
    icon: Xo
  },
  {
    name: "Norfolk Island",
    code: "NF",
    phoneCode: "+672",
    placeholder: "3 81234",
    icon: _o
  },
  {
    name: "North Korea (조선 민주주의 인민 공화국)",
    code: "KP",
    phoneCode: "+850",
    placeholder: "0192 123 4567",
    icon: er
  },
  {
    name: "North Macedonia (Северна Македонија)",
    code: "MK",
    phoneCode: "+389",
    placeholder: "072 123 456",
    icon: Io
  },
  {
    name: "Northern Mariana Islands",
    code: "MP",
    phoneCode: "+1",
    placeholder: "(670) 234-5678",
    icon: or
  },
  {
    name: "Norway (Norge)",
    code: "NO",
    phoneCode: "+47",
    placeholder: "406 12 345",
    icon: rr
  },
  {
    name: "Oman (عُمان)",
    code: "OM",
    phoneCode: "+968",
    placeholder: "9212 3456",
    icon: nr
  },
  {
    name: "Pakistan (پاکستان)",
    code: "PK",
    phoneCode: "+92",
    placeholder: "0301 2345678",
    icon: dr
  },
  {
    name: "Palau",
    code: "PW",
    phoneCode: "+680",
    placeholder: "620 1234",
    icon: ar
  },
  {
    name: "Palestine (فلسطين)",
    code: "PS",
    phoneCode: "+970",
    placeholder: "0599 123 456",
    icon: cr
  },
  {
    name: "Panama (Panamá)",
    code: "PA",
    phoneCode: "+507",
    placeholder: "6123-4567",
    icon: mr
  },
  {
    name: "Papua New Guinea",
    code: "PG",
    phoneCode: "+675",
    placeholder: "7012 3456",
    icon: pr
  },
  {
    name: "Paraguay",
    code: "PY",
    phoneCode: "+595",
    placeholder: "0961 456789",
    icon: ir
  },
  {
    name: "Peru (Perú)",
    code: "PE",
    phoneCode: "+51",
    placeholder: "912 345 678",
    icon: lr
  },
  {
    name: "Philippines",
    code: "PH",
    phoneCode: "+63",
    placeholder: "0912 345 6789",
    icon: hr
  },
  {
    name: "Pitcairn",
    code: "PN",
    phoneCode: "+870",
    placeholder: "5123",
    icon: tr
  },
  {
    name: "Poland (Polska)",
    code: "PL",
    phoneCode: "+48",
    placeholder: "512 345 678",
    icon: Cr
  },
  {
    name: "Portugal",
    code: "PT",
    phoneCode: "+351",
    placeholder: "912 345 678",
    icon: fr
  },
  {
    name: "Puerto Rico",
    code: "PR",
    phoneCode: "+1",
    placeholder: "(787) 234-5678",
    icon: $r
  },
  {
    name: "Qatar (قطر)",
    code: "QA",
    phoneCode: "+974",
    placeholder: "3312 3456",
    icon: sr
  },
  {
    name: "Réunion (La Réunion)",
    code: "RE",
    phoneCode: "+262",
    placeholder: "0692 12 34 56",
    icon: ur
  },
  {
    name: "Romania (România)",
    code: "RO",
    phoneCode: "+40",
    placeholder: "0712 345 678",
    icon: Sr
  },
  {
    name: "Russia (Россия)",
    code: "RU",
    phoneCode: "+7",
    placeholder: "8 (912) 345-67-89",
    icon: Mr
  },
  {
    name: "Rwanda",
    code: "RW",
    phoneCode: "+250",
    placeholder: "0720 123 456",
    icon: Gr
  },
  {
    name: "Saint Barthélemy",
    code: "BL",
    phoneCode: "+590",
    placeholder: "0690 30 12 34",
    icon: Br
  },
  {
    name: "Saint Helena",
    code: "SH",
    phoneCode: "+290",
    placeholder: "51234",
    icon: Ir
  },
  {
    name: "Saint Kitts and Nevis",
    code: "KN",
    phoneCode: "+1",
    placeholder: "(869) 765-1234",
    icon: gr
  },
  {
    name: "Saint Lucia",
    code: "LC",
    phoneCode: "+1",
    placeholder: "(758) 284-5678",
    icon: Ar
  },
  {
    name: "Saint Martin (partie française)",
    code: "MF",
    phoneCode: "+590",
    placeholder: "0690 30 12 34",
    icon: Nr
  },
  {
    name: "Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)",
    code: "PM",
    phoneCode: "+508",
    placeholder: "055 12 34",
    icon: Tr
  },
  {
    name: "Saint Vincent and the Grenadines",
    code: "VC",
    phoneCode: "+1",
    placeholder: "(784) 430-1234",
    icon: br
  },
  {
    name: "Samoa",
    code: "WS",
    phoneCode: "+685",
    placeholder: "601234",
    icon: Pr
  },
  {
    name: "San Marino",
    code: "SM",
    phoneCode: "+378",
    placeholder: "66 66 12 34",
    icon: yr
  },
  {
    name: "São Tomé and Príncipe (São Tomé e Príncipe)",
    code: "ST",
    phoneCode: "+239",
    placeholder: "981 2345",
    icon: Kr
  },
  {
    name: "Saudi Arabia (المملكة العربية السعودية)",
    code: "SA",
    phoneCode: "+966",
    placeholder: "055 123 4567",
    icon: Lr
  },
  {
    name: "Senegal (Sénégal)",
    code: "SN",
    phoneCode: "+221",
    placeholder: "70 123 45 67",
    icon: Rr
  },
  {
    name: "Serbia (Србија)",
    code: "RS",
    phoneCode: "+381",
    placeholder: "060 1234567",
    icon: Er
  },
  {
    name: "Seychelles",
    code: "SC",
    phoneCode: "+248",
    placeholder: "2 510 123",
    icon: kr
  },
  {
    name: "Sierra Leone",
    code: "SL",
    phoneCode: "+232",
    placeholder: "025 123456",
    icon: Fr
  },
  {
    name: "Singapore",
    code: "SG",
    phoneCode: "+65",
    placeholder: "8123 4567",
    icon: vr
  },
  {
    name: "Sint Maarten",
    code: "SX",
    phoneCode: "+1",
    placeholder: "(721) 520-1234",
    icon: Ur
  },
  {
    name: "Sint Eustatius",
    code: "BQ",
    phoneCode: "+599",
    placeholder: "318 1234",
    icon: Dr
  },
  {
    name: "Slovakia (Slovensko)",
    code: "SK",
    phoneCode: "+421",
    placeholder: "0912 123 456",
    icon: Vr
  },
  {
    name: "Slovenia (Slovenija)",
    code: "SI",
    phoneCode: "+386",
    placeholder: "031 234 567",
    icon: Hr
  },
  {
    name: "Solomon Islands",
    code: "SB",
    phoneCode: "+677",
    placeholder: "74 21234",
    icon: zr
  },
  {
    name: "Somalia (Soomaaliya)",
    code: "SO",
    phoneCode: "+252",
    placeholder: "7 1123456",
    icon: Or
  },
  {
    name: "South Africa",
    code: "ZA",
    phoneCode: "+27",
    placeholder: "071 234 5678",
    icon: wr
  },
  {
    name: "South Georgia and the South Sandwich Islands",
    code: "GS",
    phoneCode: "+500",
    placeholder: "51234",
    icon: Jr
  },
  {
    name: "South Korea (대한민국)",
    code: "KR",
    phoneCode: "+82",
    placeholder: "010-1234-5678",
    icon: Zr
  },
  {
    name: "South Sudan (جنوب السودان)",
    code: "SS",
    phoneCode: "+211",
    placeholder: "0977 123 456",
    icon: Wr
  },
  {
    name: "Spain (España)",
    code: "ES",
    phoneCode: "+34",
    placeholder: "612 34 56 78",
    icon: Yr
  },
  {
    name: "Sri Lanka (ශ්‍රී ලංකාව)",
    code: "LK",
    phoneCode: "+94",
    placeholder: "071 234 5678",
    icon: qr
  },
  {
    name: "Sudan (السودان)",
    code: "SD",
    phoneCode: "+249",
    placeholder: "091 123 4567",
    icon: jr
  },
  {
    name: "Suriname",
    code: "SR",
    phoneCode: "+597",
    placeholder: "741-2345",
    icon: Qr
  },
  {
    name: "Svalbard and Jan Mayen",
    code: "SJ",
    phoneCode: "+47",
    placeholder: "412 34 567",
    icon: xr
  },
  {
    name: "Sweden (Sverige)",
    code: "SE",
    phoneCode: "+46",
    placeholder: "070-123 45 67",
    icon: Xr
  },
  {
    name: "Switzerland (Schweiz)",
    code: "CH",
    phoneCode: "+41",
    placeholder: "078 123 45 67",
    icon: _r
  },
  {
    name: "Syria (سوريا)",
    code: "SY",
    phoneCode: "+963",
    placeholder: "0944 567 890",
    icon: en
  },
  {
    name: "Taiwan (台灣)",
    code: "TW",
    phoneCode: "+886",
    placeholder: "0912 345 678",
    icon: on
  },
  {
    name: "Tajikistan",
    code: "TJ",
    phoneCode: "+992",
    placeholder: "917 12 3456",
    icon: rn
  },
  {
    name: "Tanzania",
    code: "TZ",
    phoneCode: "+255",
    placeholder: "0621 234 567",
    icon: nn
  },
  {
    name: "Thailand (ไทย)",
    code: "TH",
    phoneCode: "+66",
    placeholder: "081 234 5678",
    icon: dn
  },
  {
    name: "Timor-Leste",
    code: "TL",
    phoneCode: "+670",
    placeholder: "7721 2345",
    icon: an
  },
  {
    name: "Togo",
    code: "TG",
    phoneCode: "+228",
    placeholder: "90 11 12 34",
    icon: cn
  },
  {
    name: "Tokelau",
    code: "TK",
    phoneCode: "+690",
    placeholder: "7290",
    icon: mn
  },
  {
    name: "Tonga",
    code: "TO",
    phoneCode: "+676",
    placeholder: "771 5123",
    icon: pn
  },
  {
    name: "Trinidad and Tobago",
    code: "TT",
    phoneCode: "+1",
    placeholder: "(868) 291-1234",
    icon: ln
  },
  {
    name: "Tunisia (تونس)",
    code: "TN",
    phoneCode: "+216",
    placeholder: "20 123 456",
    icon: hn
  },
  {
    name: "Turkey (Türkiye)",
    code: "TR",
    phoneCode: "+90",
    placeholder: "0501 234 5678",
    icon: tn
  },
  {
    name: "Turkmenistan",
    code: "TM",
    phoneCode: "+993",
    placeholder: "8 66 123456",
    icon: Cn
  },
  {
    name: "Turks and Caicos Islands",
    code: "TC",
    phoneCode: "+1",
    placeholder: "(649) 231-1234",
    icon: fn
  },
  {
    name: "Tuvalu",
    code: "TV",
    phoneCode: "+688",
    placeholder: "901234",
    icon: $n
  },
  {
    name: "U.S. Virgin Islands",
    code: "VI",
    phoneCode: "+1",
    placeholder: "(340) 642-1234",
    icon: In
  },
  {
    name: "Uganda",
    code: "UG",
    phoneCode: "+256",
    placeholder: "0712 345678",
    icon: sn
  },
  {
    name: "Ukraine (Україна)",
    code: "UA",
    phoneCode: "+380",
    placeholder: "039 123 4567",
    icon: un
  },
  {
    name: "United Arab Emirates (الإمارات العربية المتحدة)",
    code: "AE",
    phoneCode: "+971",
    placeholder: "050 123 4567",
    icon: Mn
  },
  {
    name: "United Kingdom",
    code: "GB",
    phoneCode: "+44",
    placeholder: "07700 900123",
    icon: Sn
  },
  {
    name: "United States",
    code: "US",
    phoneCode: "+1",
    placeholder: "(201) 555-0123",
    icon: Gn
  },
  {
    name: "Uruguay",
    code: "UY",
    phoneCode: "+598",
    placeholder: "091 234 567",
    icon: Bn
  },
  {
    name: "Uzbekistan (Oʻzbekiston)",
    code: "UZ",
    phoneCode: "+998",
    placeholder: "8 91 234 56 78",
    icon: gn
  },
  {
    name: "Vanuatu",
    code: "VU",
    phoneCode: "+678",
    placeholder: "591 2345",
    icon: An
  },
  {
    name: "Vatican City (Città del Vaticano)",
    code: "VA",
    phoneCode: "+379",
    placeholder: "3123456789",
    icon: Nn
  },
  {
    name: "Venezuela",
    code: "VE",
    phoneCode: "+58",
    placeholder: "0412-1234567",
    icon: Tn
  },
  {
    name: "Vietnam (Việt Nam)",
    code: "VN",
    phoneCode: "+84",
    placeholder: "091 234 56 78",
    icon: bn
  },
  {
    name: "Wallis and Futuna (Wallis-et-Futuna)",
    code: "WF",
    phoneCode: "+681",
    placeholder: "50 12 34",
    icon: Pn
  },
  {
    name: "Western Sahara (الصحراء الغربية)",
    code: "EH",
    phoneCode: "+212",
    placeholder: "0650-123456",
    icon: yn
  },
  {
    name: "Yemen (اليمن)",
    code: "YE",
    phoneCode: "+967",
    placeholder: "0712 345 678",
    icon: Kn
  },
  {
    name: "Zambia",
    code: "ZM",
    phoneCode: "+260",
    placeholder: "095 1234567",
    icon: Ln
  },
  {
    name: "Zimbabwe",
    code: "ZW",
    phoneCode: "+263",
    placeholder: "071 123 4567",
    icon: Rn
  }
];
export {
  lp as countryDetails
};
